import api from './api';

// Helper para extrair dados da resposta
// NOTA: ReferenceHandler.Preserve foi removido da API
// Agora a API retorna arrays e objetos normais sem $values
const extractData = (data) => {
  // Se for um objeto com $values (legacy), extrair o array
  if (data && typeof data === 'object' && data.$values) {
    return data.$values;
  }
  // Retornar como está (array ou objeto)
  return data;
};

const professionalsService = {
  // Listar todos os profissionais (sempre retorna dados completos - BFF)
  getAll: async () => {
    const response = await api.get('/professionals');
    return extractData(response.data);
  },

  // Buscar profissional por ID
  getById: async (id) => {
    const response = await api.get(`/professionals/${id}`);
    return extractData(response.data);
  },

  // Criar novo profissional
  create: async (data) => {
    const response = await api.post('/professionals', data);
    return extractData(response.data);
  },

  // Atualizar profissional
  update: async (id, data) => {
    const response = await api.put(`/professionals/${id}`, data);
    return extractData(response.data);
  },

  // Deletar profissional
  delete: async (id) => {
    const response = await api.delete(`/professionals/${id}`);
    return extractData(response.data);
  },

  // Buscar locais e agendas vinculados a um profissional
  // Usado no editor de Página Profissional para configurar o agendamento integrado
  // Response: [{ placeProfessionalId, place: { id, name, address }, schedules: [{ id, name, isActive }] }]
  getPlacesSchedules: async (professionalId) => {
    const response = await api.get(`/professionals/${professionalId}/places-schedules`);
    return extractData(response.data);
  },
};

export default professionalsService;
